<template>
  <div class="driver-report-info">
    <div class="search-form-box">
      <el-row :gutter="30">
        <el-form inline>
          <el-col :span="5">
            <el-form-item label="搜索:">
              <el-input
                style="width: 100%"
                v-model="topSearchValue"
                placeholder="请输入司机姓名或手机号码或车牌号码"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="更新时间:">
              <el-date-picker
                style="width: 100%"
                clearable
                v-model="searchForm.keyword"
                autocomplete="off"
                placeholder="请选择"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="所属机构:">
              <el-select
                style="width: 100%"
                clearable
                v-model="searchForm.roleId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in roleData"
                  :key="item.roleId"
                  :label="item.roleName"
                  :value="item.roleId"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="可装容量:">
              <el-select
                style="width: 100%"
                clearable
                v-model="searchForm.status"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in $dict.statusOptions"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="可装重量:">
              <el-select
                style="width: 100%"
                clearable
                v-model="searchForm.status"
                placeholder="省/市/区"
              >
                <el-option
                  v-for="item in $dict.statusOptions"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="">
              <el-button
                type="default"
                round
                icon="el-icon-search"
                @click="handleReset()"
              ></el-button>
              <el-button
                type="primary"
                round
                icon="el-icon-refresh"
                @click="handleCheck()"
              ></el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </div>
    <div class="custom-table-box">
      <custom-table
        :data="tableData"
        :column="tableColumn"
        :total="tableOptions.total"
        :loading="tableOptions.loading"
        :page="tableOptions.pageNumber"
        :size="tableOptions.pageSize"
        :selection="false"
        @pagination="handleSizeChange"
      >
        <template v-slot:status="{ row }">
          <span @click="handleStatus(row)">
            {{ row.status }}
            <!--            <el-switch-->
            <!--              :value="row.status"-->
            <!--              :inactive-value="0"-->
            <!--              :active-value="1"-->
            <!--              size="medium"-->
            <!--              active-color="#526BEC"-->
            <!--            >-->
            <!--            </el-switch>-->
          </span>
        </template>
        <template v-slot:operation="{ row }">
          <div v-if="!row.internal">
            <span class="operate-btn" @click.stop="handleEdit(row)">编辑</span>
            <span
              class="operate-btn colorf32009"
              @click="handleDelete(row.userId, '确定要删除此账号吗？')"
              >删除</span
            >
          </div>
        </template>
      </custom-table>
    </div>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import { deleteInfo, enableUser, getPage } from "../api";
import tableMixin from "@/mixin/tableMixin";
import { getRoleSelect } from "@/views/commonApi";
import CustomTabBox from "@/components/customComponents/CustomTabBox.vue";
export default {
  name: "Staff-management",
  // mixins: [tableMixin],
  components: {
    CustomTabBox,
    OperateBox,
    CustomTable,
  },
  data() {
    return {
      getTableMethod: getPage,
      deleteMethod: deleteInfo,
      topSearchValue: "",
      isImmediatelyGetData: false,
      tabData: [
        {
          label: 1,
          value: "司机上报信息",
        },
        {
          label: 2,
          value: "司机派单信息",
        },
        {
          label: 3,
          value: "车辆仓位信息",
        },
      ],
      searchForm: {
        keyword: "",
        terminalType: "1",
        roleId: "",
        status: "",
      },
      orgId: [],
      departTree: [], // 部门树
      tableColumn: [
        {
          label: "司机姓名",
          prop: "account",
          show: true,
        },
        {
          label: "所属机构",
          prop: "phone",
          show: true,
        },
        {
          label: "手机号码",
          prop: "username",
          show: true,
        },
        {
          label: "车牌号码",
          prop: "roleName",
          show: true,
        },
        {
          label: "剩余可装容量",
          prop: "status",
          show: true,
        },
        {
          label: "剩余可装重量",
          prop: "createTime",
          show: true,
        },
        {
          label: "仓位状态更新时间",
          prop: "createTime",
          show: true,
        },
        // {
        //   label: "操作",
        //   prop: "operation",
        //   width: "150px",
        //   scopeStatus: true,
        //   fixed: "right",
        //   show: true,
        // },
      ],
      multipleSelection: [],
      roleData: [],
      statisticsImage1: require("@/assets/imgs/huozhuzongliang.png"),
      statisticsImage2: require("@/assets/imgs/siji_sb.png"),
    };
  },
  watch: {
    "searchForm.terminalType": {
      handler(val) {
        this.getRoleData(val);
        this.searchForm.roleName = "";
        this.searchForm.roleId = "";
        this.searchForm.status = "";
        this.searchPage();
      },
    },
  },
  created() {
    this.getRoleData(1);
  },
  mounted() {},
  methods: {
    handleChange(val) {
      // // console.log("val111111111", val);
    },
    getRoleData(terminalType) {
      getRoleSelect(terminalType).then((res) => {
        if (res.code === 200) {
          this.roleData = res.data;
        }
      });
    },
    handleReset() {
      this.searchForm.keyword = "";
      this.searchForm.roleName = "";
      this.searchForm.status = "";
      this.tableOptions.currentPage = 1;
      this.searchPage();
    },
    handleAdd() {
      this.$refs.addOrEdit.init(this.searchForm.terminalType);
    },
    handleEdit(row) {
      this.$refs.addOrEdit.init(this.searchForm.terminalType, row);
    },
    handleStatus(row) {
      this.$confirm(`确定${!row.status ? "启用" : "禁用"}此用户？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        enableUser({ userId: row.userId, status: row.status ? 0 : 1 }).then(
          (res) => {
            if (res.code === 200) {
              this.getTableData();
            }
          }
        );
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.driver-report-info {
  .search-form-title {
    font-weight: 400;
    font-size: 0.16rem;
    color: #111827;
    line-height: 0.24rem;
    padding-bottom: 0.08rem;
  }
  .drop-image {
    width: 0.24rem;
    height: 0.24rem;
  }
  .custom-table-box {
    padding-bottom: 0.68rem;
  }
  .statistics-box {
    display: flex;
    justify-content: space-around;
    padding: 0 0.16rem;
    margin: 0 -0.1rem;
    .statistics-list {
      width: 33.33%;
      height: 1.2rem;
      background-color: #fbfcff;
      border-radius: 0.08rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.2rem;
      box-sizing: border-box;
      margin: 0 0.1rem;
      .statistics-image {
        width: 0.8rem;
        height: 0.61rem;
      }
      .statistics-num {
        .num {
          font-size: 0.24rem;
          color: #000000;
          font-weight: bold;
        }
        .txt {
          font-size: 0.14rem;
          color: #434343;
          padding-top: 0.1rem;
        }
      }
    }
  }
  .tab-check-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.2rem;
    box-sizing: border-box;
  }
}
</style>
